import Phaser from "phaser";
import { BaseToast } from "@phaser/ui/toast/BaseToast";

export class AlertToast extends BaseToast {
  constructor(
    scene: Phaser.Scene,
    x: number,
    y: number,
    message: string,
    onClose?: () => void,
  ) {
    super(scene, {
      x,
      y,
      duration: 1000,
      onClose,
    });

    const bg = scene.add.image(0, 0, "s-toast-bg").setOrigin(0.5);

    const text = scene.add
      .text(0, 0, message, {
        fontFamily: "Black Han Sans",
        fontSize: "48px",
        color: "#1C120E",
        align: "center",
      })
      .setOrigin(0.5);

    this.add([bg, text]);
  }
}
